import { ProductCardMetadataBadgeItemsItemsProps, useTheme } from '@croquiscom-pvt/zds';
import { css } from '@emotion/react';

export interface BadgeItemProps extends Omit<ProductCardMetadataBadgeItemsItemsProps, 'className'> {
  className?: string;
  darkImageUrl: string | null;
  imageUrl: string | null;
  height?: number;
}

export const BadgeItem = (props: BadgeItemProps) => {
  const { className, darkImageUrl, imageUrl, height } = props;

  const { colorScheme } = useTheme();

  if (colorScheme === 'system') {
    if (!imageUrl) {
      return null;
    }

    return (
      <picture>
        {darkImageUrl && <source srcSet={darkImageUrl} media='(prefers-color-scheme: dark)' />}
        <img className={className} src={imageUrl} alt='' css={height ? imageStyle(height) : undefined} />
      </picture>
    );
  }

  if (colorScheme === 'dark') {
    const src = darkImageUrl ?? imageUrl;
    if (!src) {
      return null;
    }
    return <img className={className} src={src} alt='' css={height ? imageStyle(height) : undefined} />;
  }

  if (!imageUrl) {
    return null;
  }

  return <img className={className} src={imageUrl} alt='' css={height ? imageStyle(height) : undefined} />;
};

const imageStyle = (height: number) => css`
  height: ${height}px;
`;
